import { render } from "./reverseDisposition.vue?vue&type=template&id=9640e61a&scoped=true"
import script from "./reverseDisposition.vue?vue&type=script&lang=js"
export * from "./reverseDisposition.vue?vue&type=script&lang=js"

import "./reverseDisposition.vue?vue&type=style&index=0&id=9640e61a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9640e61a"]])

export default __exports__